import ExportFormController from './export.form.controller';

export default {
    template: require('./export.form.html'),
    controller: ExportFormController
};
